import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { UserContext } from '../../../context/authContext';
import { useNavigate } from 'react-router-dom';
import { buttonStyle } from '../style/styleSet';

const SignupComplete: React.FC = () => {
  const { updateToken, rehydrateAuth, logout } = useContext(UserContext);
  const navigate = useNavigate();
  const handleGo = async () => {
    updateToken();
  };
  return (
    <div className="fixed inset-0 overscroll-none overflow-hidden w-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#62d29e]/40 via-[#62d29e]/20 to-white dark:from-slate-950 dark:via-slate-950 dark:to-black flex items-center justify-center p-6">
      {/* Subtle grid overlay */}
      <div className="pointer-events-none fixed inset-0 opacity-[0.04] [background-image:linear-gradient(to_right,theme(colors.slate.500/.35)_1px,transparent_1px),linear-gradient(to_bottom,theme(colors.slate.500/.35)_1px,transparent_1px)] [background-size:32px_32px]" />

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        className="relative z-10 w-full max-w-md"
      >
        <div className="rounded-2xl border border-black/5 dark:border-white/10 bg-white/80 dark:bg-slate-900/70 backdrop-blur-xl shadow-[0_20px_60px_-20px_rgba(0,0,0,0.4)]">
          {/* Header */}
          <div className="px-8 pt-8 pb-4 text-center">
            <img
              src="/korulogo.png"
              alt="Koru Logo"
              className="mx-auto mb-4 h-12 w-12 object-contain"
              loading="eager"
              decoding="async"
            />
            <h1 className="text-2xl font-semibold text-slate-900 dark:text-white">
              Sign‑up Complete
            </h1>
          </div>
          <form
            className=" px-8 pb-8 pt-4 space-y-5"
            onSubmit={(e) => e.preventDefault()}
          >
            {/* Body */}
            <div className="px-8 pb-8 pt-2 text-center">
              <p className="text-base leading-relaxed text-slate-700 dark:text-slate-200">
                <span className="font-medium">Congratulations</span> — you can
                now experience all that{' '}
                <span className="font-semibold">Koru</span> has to offer.
              </p>
            </div>
            <button className={buttonStyle} onClick={() => handleGo()}>
              Get Started
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default SignupComplete;
